// What `createShotInEpisode` (newShot.ts) needs to pick the next shot code, read without loading the whole
// production: its episodes, the scenes and shots of one episode, and the codes of every shot of the production.
import type { Api } from "../api.ts";
import type { Project, Shot } from "../types.ts";
import type { ProjectData } from "../useProject.ts";

export async function loadProjectForNewShot(
  api: Api,
  ws: string,
  project: Project,
  episodeId: string,
): Promise<ProjectData> {
  const [episodes, scenes, all] = await Promise.all([
    api.listEpisodes(ws, project.id),
    api.listScenes(ws, episodeId),
    api.listShots(ws, { projectId: project.id }),
  ]);
  const shots = new Map<string, Shot[]>(
    await Promise.all(scenes.map(async (s) => [s.id, await api.listShotsOfScene(ws, s.id)] as const)),
  );
  return {
    project,
    episodes,
    scenes: new Map([[episodeId, scenes]]),
    shots,
    shotHome: new Map(),
    shotById: new Map(all.map((s) => [s.id, s])),
    takes: new Map(),
    sceneTakes: new Map(),
    generations: new Map(),
    costs: new Map(),
    elements: [],
    canvases: [],
  };
}
